module.exports = __webpack_public_path__ + "img/WILLIAMHILL.3cacf4f9.svg";